module.exports = __webpack_public_path__ + "media/images/extension-image-d51bd760af682969714c2a5526734f14.png";